var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"60vw"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(
      _vm.item &&
        (_vm.item.type == 'PNG' ||
          _vm.item.type == 'JPG' ||
          _vm.item.type == 'JPEG' ||
          _vm.item.type == 'BMP' ||
          _vm.item.type == 'png' ||
          _vm.item.type == 'jpg' ||
          _vm.item.type == 'jpeg' ||
          _vm.item.type == 'bmp')
    )?_c('v-card',[_c('v-card-text',[_c('v-img',{attrs:{"max-width":"60vw","max-height":"70vh","src":_vm.item.url,"contain":""}})],1)],1):(_vm.item && (_vm.item.type == 'pdf' || _vm.item.type == 'PDF'))?_c('div',[_c('PdfPenunjang',{staticStyle:{"max-width":"60vw","max-height":"100vh"},attrs:{"item":_vm.item,"zoom":(_vm.tipe = 'zoom')}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }